import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import { User } from "../../models/user";
import * as appGlobal from "../../services/global/globals";


@Injectable()
export class AuthService {
  private token: string;
  private expiry: Date;
  private User: User;

  constructor() { }


  checkLogin(): boolean {
    return this.getLocalToken() != null && (this.getLocalExpiry() >= new Date());
  }

  private getLocalToken(): string {
    if (!this.token) {
      this.token = sessionStorage.getItem(appGlobal.tokenKey);
    }

    return this.token;
  }

  private getLocalExpiry(): Date {
    if (!this.expiry) {
      this.expiry = new Date(sessionStorage.getItem(appGlobal.expiryKey));
    }
    return this.expiry;
  }

  getLocalUser(): User {
    try {
      this.User = JSON.parse(sessionStorage.getItem(appGlobal.userKey));
    }
    catch (e) {
      if (e instanceof SyntaxError) {
        console.log(e + 'SyntaxError ');
      }
    }
    return this.User;
  }

  initAuthHeaders(): Headers {

    let token = this.getLocalToken();
    if (token == null) throw "No token";

    var headers = new Headers();
    headers.append("Authorization", "Bearer " + token);

    return headers;
  }


  logout() {
    // Clear the session Storage
    sessionStorage.clear();

    // Clear the session variables
    this.token = null;
    this.expiry = null;
    this.User = null;

  }

}
















// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/auth/auth.service.ts